import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, TypeProvider } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import {
  ENV_VARIABLES,
  IEnvironment,
  IWidgetEnvironment,
} from '@nibtravel/shared/util/constants';
import { DomModule } from '@nibtravel/shared/util/dom';

import { AppConfigService } from './app-config.service';
import { AppInitializerService } from './app.initializer';
import { APP_CONFIG_SVC } from './models';
import { AppConfigState } from './state/app-config.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([AppConfigState]), DomModule],
  providers: [
    AppConfigService,
    { provide: APP_CONFIG_SVC, useValue: AppConfigService },
  ],
})
export class AppConfigModule {
  static forRoot(
    env: IEnvironment | IWidgetEnvironment,
    customSvc?: TypeProvider
  ): ModuleWithProviders<AppConfigModule> {
    return {
      ngModule: AppConfigModule,
      providers: [
        AppInitializerService,
        { provide: ENV_VARIABLES, useValue: env },
        { provide: APP_CONFIG_SVC, useValue: customSvc ?? AppConfigService },
      ],
    };
  }
}
